import React from "react";
import { Skeleton } from "@common/skeleton";
import { Project } from "./project";
import styles from "./styles.scss";

function Loader() {
  return (
    <ul className={styles.list}>
      <li className={styles.item}>
        <Project />
      </li>
      <li className={styles.item}>
        <Project />
      </li>
      <li className={styles.item}>
        <Project />
      </li>
    </ul>
  );
}

export { Loader };
